import React, { useEffect, useCallback, useState } from "react";
import { useMutation } from "@apollo/react-hooks";

import PhotoUploadPhotoShootMasthead from "./PhotoUploadPhotoShootMasthead";
import PhotoUploadLayout from "../PhotoUploadCore/PhotoUploadLayout";
import InitializePhotoUploads from "../PhotoUploadCore/InitializePhotoUploads";
import PhotoUploadProviders from "../PhotoUploadCore/PhotoUploadProviders";
import RedirectOnInvalidReferrer from "../PhotoUploadCore/RedirectOnValidReferrer";

import { useExistingUploads } from "../PhotoUploadCore/hooks";
import { usePhotoUpload } from "frontend/hooks/usePhotoUpload";

import { CREATE_PHOTO_SHOOT } from "./mutations";

const PhotoUploadPhotoShootUnwrapped = () => {
    const { existingPhotoShootId, shootDataLoaded } = useExistingUploads();
    const { setCurrentPhotoShootId, currentPhotoShootId } = usePhotoUpload();

    const [shootCreated, setShootCreated] = useState(false);

    const [createPhotoShoot] = useMutation(CREATE_PHOTO_SHOOT, {
        onCompleted: data => {
            if (!data.createPhotoShoot.ok) return;

            // setting `currentPhotoShootId` allows for uploads
            // to be attached to that photo shoot
            setCurrentPhotoShootId(data.createPhotoShoot.photoShoot.id);
        }
    });

    useEffect(() => {
        if (!shootDataLoaded) return;

        if (existingPhotoShootId) {
            // setting `currentPhotoShootId` allows for uploads
            // to be attached to that photo shoot
            setCurrentPhotoShootId(existingPhotoShootId);
            return setShootCreated(true);
        }

        if (!shootCreated) {
            createPhotoShoot();
            return setShootCreated(true);
        }
    }, [existingPhotoShootId, shootDataLoaded]);

    return (
        <>
            <RedirectOnInvalidReferrer />
            <PhotoUploadLayout
                masthead={useCallback(
                    () => (
                        <PhotoUploadPhotoShootMasthead
                            currentPhotoShootId={currentPhotoShootId}
                        />
                    ),
                    [currentPhotoShootId]
                )}
            />
        </>
    );
};

const PhotoUploadPhotoShoot = props => (
    <PhotoUploadProviders>
        <InitializePhotoUploads>
            <PhotoUploadPhotoShootUnwrapped {...props} />
        </InitializePhotoUploads>
    </PhotoUploadProviders>
);

export default PhotoUploadPhotoShoot;
